import {Injectable} from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import Swal from 'sweetalert2';



@Injectable({
    providedIn: 'root'
})
export class LoadingService {
private static loaderEnabled: boolean;
    constructor(private router: Router,) {
    }
    simpleNotification(){
      Swal.fire('Simple Notification');
    }

    successNotification(){
      Swal.fire('Hi', 'We have been informed!', 'success')
    }

     errorNotification(){
      Swal.fire('Hi', 'We have been informed!', 'error')
    }

    alertConfirmation(){
      Swal.fire({
        position: 'top-end',
        title: 'Are you sure?',
        text: 'This process is irreversible.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, go ahead.',
        cancelButtonText: 'No, let me think'
      }).then((result) => {
        if (result.value) {
          Swal.fire(
            'Removed!',
            'Item removed successfully.',
            'success'
          )
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Item is safe.)',
            'error'
          )
        }
      })
    }


    async emailNotification(){
      const { value: email } = await Swal.fire({
          //position: 'bottom-end',
          title: 'Input email address',
          input: 'email',
          inputPlaceholder: 'Enter your email address'
        })

        if (email) {
          Swal.fire(`Entered email: ${email}`)
        }
    }



    async certificadoNotificacion(){

    Swal.fire({
      // position: 'top-end',
       title: 'Usted no cuenta con certificado digital',
       text: 'Deseas subir el certificado...?',
       icon: 'warning',
       showCancelButton: true,
       confirmButtonText: 'Si, deseo subir.',
       cancelButtonText: 'No, Continuar'
     }).then((result) => {
       if (result.value) {
         this.router.navigate(['/facturador/Certificado']);
       } else if (result.dismiss === Swal.DismissReason.cancel) {

       }
     })
    }
     EstablecimientoNotificacion(){
      Swal.fire({
        // position: 'top-end',
         title: 'Usted no cuenta con Establecimiento',
         text: 'Sera dirigido a Establecimiento',
         icon: 'warning',
         confirmButtonText: 'OK',
       }).then((result) => {
         if (result.value) {
           this.router.navigate(['/facturador/Establecimiento']);
         }
       })
      }
      Notificacionredireccion(pagina:string,model:string){
        Swal.fire({
          // position: 'top-end',
           title: 'Usted no cuenta con '+ model,
           text: 'Deseas crear un '+model+'...?',
           icon: 'warning',
           confirmButtonText: 'Si, deseo crear.',
         }).then((result) => {
           if (result.value) {
             this.router.navigate([pagina]);
           }
         })
        }
    isLoading = new Subject<boolean>();
    showloadingPersonalizado(mensaje:string){
      Swal.fire({
        icon: "info",
        allowOutsideClick: false,
        title: mensaje,
        text: 'Espere, por favor!...',
        timer: 50000
    }); Swal.showLoading(Swal.getConfirmButton())
    }
    showloadingcargainicial(){
      Swal.fire({
        icon: "info",
        allowOutsideClick: false,
        title: "Cargando informaciòn inicial",
        text: 'Espere, por favor!...',
        timer: 50000
    }); Swal.showLoading(Swal.getConfirmButton())
    }

    showloading(){
      Swal.fire({
        icon: "info",
        allowOutsideClick: false,
        title: 'Procesando Información',
        text: 'Espere, por favor!...',
        timer: 50000
    }); Swal.showLoading(Swal.getConfirmButton())
    }
    presentarerror(mensaje:string){
      let   htmlfinal="class='' style='color: red'"
      htmlfinal="<h5 " + htmlfinal + ">" +mensaje

      Swal.fire({
        html:htmlfinal,
        icon: 'error',
       width:'400px',
       confirmButtonText: '<i class="fa fa-thumbs-up"></i> Aceptar!',
        confirmButtonColor: '#556ee6'
      });
    }
    presentarOK(mensaje:string){
      Swal.fire({
        text:mensaje,
        icon: 'success',
       width:'300px',
       confirmButtonText: '<i class="fa fa-thumbs-up"></i> Aceptar!',
      confirmButtonColor: '#556ee6'
      });
    }
    presentarinfo(mensaje:string){
      Swal.fire({
        text:mensaje,
        icon: 'info',
       width:'300px',
       confirmButtonText: '<i class="fa fa-thumbs-up"></i> Aceptar!',
      confirmButtonColor: '#556ee6'
      });
    }
    closeLoading(){

      Swal.close();
    }
}
